<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('push.toPage')" prop="toPage">
                <a-select v-model="queryParam.toPage" :placeholder="$t('common.select')" allow-clear>
                  <a-select-option value="1">{{ $t('push.toPage1') }}</a-select-option>
                  <a-select-option value="2">{{ $t('push.toPage2') }}</a-select-option>
                  <a-select-option value="3">{{ $t('push.toPage3') }}</a-select-option>
                  <a-select-option value="4">{{ $t('push.toPage4') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('push.toUser')" prop="toUser">
                <a-select v-model="queryParam.toUser" :placeholder="$t('common.select')" allow-clear>
                  <a-select-option value="1">{{ $t('push.toUser1') }}</a-select-option>
                  <a-select-option value="2">{{ $t('push.toUser2') }}</a-select-option>
                  <a-select-option value="3">{{ $t('push.toUser3') }}</a-select-option>
                  <a-select-option value="4">{{ $t('push.toUser4') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['video:push:add']">
          <a-icon type="plus" />{{ $t('common.add') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['video:push:remove']">
          <a-icon type="delete" />{{ $t('common.delete') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="sendTime" slot-scope="text, record">
          {{ parseTime(record.sendTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['video:push:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['video:push:edit']">
            <a-icon type="edit" />{{ $t('common.edit') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['video:push:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['video:push:remove']">
            <a-icon type="delete" />{{ $t('common.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pagePush, listPush, delPush } from '@/api/video/push'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Push',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        content: null,
        contentEn: null,
        toPage: null,
        toUser: null,
        timeType: null,
        sendTime: null,
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    columns() {
      const that = this
      return [
        {
          title: this.$t('push.title'),
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('push.titleEn'),
          dataIndex: 'titleEn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('push.content'),
          dataIndex: 'content',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('push.contentEn'),
          dataIndex: 'contentEn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('push.toPage'),
          dataIndex: 'toPage',
          ellipsis: true,
          align: 'center',
          customRender: function (toPage) {
            if (toPage == 1) {
              return that.$t('push.toPage1')
            } else if (toPage == 2) {
              return that.$t('push.toPage2')
            } else if (toPage == 3) {
              return that.$t('push.toPage3')
            } else if (toPage == 4) {
              return that.$t('push.toPage4')
            }
          }
        },
        {
          title: this.$t('push.toUser'),
          dataIndex: 'toUser',
          ellipsis: true,
          align: 'center',
          customRender: function (toUser) {
            if (toUser == 1) {
              return that.$t('push.toUser1')
            } else if (toUser == 2) {
              return that.$t('push.toUser2')
            } else if (toUser == 3) {
              return that.$t('push.toUser3')
            } else if (toUser == 4) {
              return that.$t('push.toUser4')
            }
          }
        },
        {
          title: this.$t('push.sendTime'),
          dataIndex: 'sendTime',
          scopedSlots: { customRender: 'sendTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('table.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  watch: {
  },
  methods: {
    /** 查询平台推送列表 */
    getList () {
      this.loading = true
      pagePush(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        content: undefined,
        toPage: undefined,
        toUser: undefined,
        timeType: undefined,
        sendTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    // onShowSizeChange 方法已在 tableMixin 中统一处理，无需重复定义
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('video.confirmDelete'),
        content: this.$t('video.confirmDeleteContent') + ids,
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delPush(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('common.deleteSuccess'),
                3
              )
            })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('video.confirmExport'),
        content: this.$t('video.confirmExportContent'),
        onOk () {
          that.download('video/platform-push/export', {
            ...that.queryParam
          }, `${that.$t('push.exportFileName')}_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
